<template>
  <div class="kpb-article-portal">
    <h3 class="kpb-article-portal__title">{{ item.title }}</h3>
    <div v-html="`${item.content}`.substring(0, 100) + '...'" class="kpb-article-portal__content"></div>

    <div class="kpb-article-portal__read-more">
      <span class="kpb-article-portal__read-more-content">{{ $tc('readMore') }}</span>
      <!-- Arrow -->
      <svg
        v-if="!hideArrow"
        class="kpb-article-portal__read-more-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      default: 'cards',
      enums: ['cards', 'masonry'],
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getStatus(item) {
      if (categoryMap[item]) return categoryMap[item]

      return categoryMap['development']
    },
  },
}
</script>

<style lang="scss">
.kpb-article-portal {
  word-break: normal;
  &__content {
    font-size: 0.9rem;
    &__title,
    h2 {
      color: initial;
      font-family: var(--primary-font);
      font-size: 0.9rem;
      margin-bottom: 0;
    }
    p {
      margin: 0em;
    }
  }

  &__title {
    color: var(--primary);
    font-size: 1.3rem;
    font-family: var(--primary-font);
    margin: 0.5rem 0;
  }

  &__read-more {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.8rem;
    &-content {
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 2px;
    }
    &-icon {
      height: 1em;
    }
  }
}
</style>
